// src/components/common/Dialog.jsx
//
// Diálogo modal accesible para formularios: role="dialog", nombre accesible,
// foco contenido y devuelto al disparador, y cierre (Escape, clic fuera o botón)
// que respeta borradores: con `dirty` pide confirmar antes de descartar.
// Solo aporta el marco; el aspecto lo dan overlayClassName / className.
import React, { useRef, useState } from 'react';
import ConfirmModal from './ConfirmModal';
import useDialogFocus from './useDialogFocus';

const Dialog = ({ labelledBy, label, onClose, dirty = false, language = 'es', overlayClassName = '', className = '', onInput, children }) => {
  const es = language === 'es';
  const ref = useRef(null);
  const [confirming, setConfirming] = useState(false);
  const requestClose = () => { if (dirty) setConfirming(true); else onClose(); };
  const onKeyDown = useDialogFocus(ref, { onEscape: requestClose });

  return (
    <>
      <div className={overlayClassName} onClick={event => { if (event.target === event.currentTarget) requestClose(); }}>
        <div
          ref={ref}
          role="dialog"
          aria-modal="true"
          aria-labelledby={labelledBy}
          aria-label={labelledBy ? undefined : label}
          tabIndex={-1}
          className={className}
          onKeyDown={onKeyDown}
          onInput={onInput}
        >
          {typeof children === 'function' ? children({ requestClose }) : children}
        </div>
      </div>
      <ConfirmModal
        open={confirming}
        icon="fa-triangle-exclamation"
        danger
        title={es ? 'Descartar cambios' : 'Discard changes'}
        message={es ? 'Empezaste a llenar este formulario. Si lo cierras, se pierde lo escrito.' : 'You started filling in this form. If you close it, what you typed is lost.'}
        confirmLabel={es ? 'Descartar' : 'Discard'}
        cancelLabel={es ? 'Seguir editando' : 'Keep editing'}
        closeLabel={es ? 'Cerrar' : 'Close'}
        onConfirm={() => { setConfirming(false); onClose(); }}
        onCancel={() => setConfirming(false)}
      />
    </>
  );
};

export default Dialog;
